export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

export const DEVICE_CODE = "view.device-code";
export const ACCESS_TOKEN = "view.access-token";
export const REFRESH_TOKEN = "view.refresh-token";
export const EXPIRATION_DATE = "view.expiration-date";
